import { Component, OnInit, Input } from '@angular/core';
import { ValidCharactersSettings, CharactersValidation } from '../strong-password/valid-characters';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'password-feedback',
  templateUrl: './password-feedback.component.html',
  styleUrls: ['./password-feedback.component.css'],
})
export class PasswordFeedbackComponent implements OnInit {
  @Input() passwordControl: FormControl<string>;
  @Input() confirmPasswordControl: FormControl<string>;

  constructor() {}

  ngOnInit() {}
}
